import Odometer from "odometer";

export default class WhyUsBlock {
	constructor() {
		this.events();
	}

	events() {
		this.observeSection();
		document.addEventListener("gutenbergWidthChanged", this.animateNumbers);
	}

	observeSection() {
		const section = document.querySelector(".why-us");

		const self = this;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						self.animateNumbers();
						observer.unobserve(section);
					}
				});
			},
			{
				threshold: 0.5,
				rootMargin: "100px",
			}
		);

		if (section) {
			observer.observe(section);
		}
	}

	animateNumbers() {
		const counters = document.querySelectorAll(".counter");

		counters.forEach((counter) => {
			const number = parseInt(counter.dataset.number);
			const duration = parseInt(counter.dataset.duration ?? 1000);

			let odometer = new Odometer({
				el: counter,
				value: 0,
				theme: "minimal",
				duration: duration,
			});

			odometer.update(number);
		});
	}
}
